export const getImageUrl = (imagePath) => {
    if (!imagePath || typeof imagePath !== 'string') {
      return '';
    }
    const normalizedPath = imagePath.trim();
    if (!normalizedPath) {
      return '';
    }
    if (normalizedPath.startsWith('http') || normalizedPath.startsWith('blob:') || normalizedPath.startsWith('data:')) {
      return normalizedPath;
    }
    const baseUrl = process.env.REACT_APP_BASE_URL || '';
    return `${baseUrl}${normalizedPath.startsWith('/') ? '' : '/'}${normalizedPath}`;
};

// Inverse of getImageUrl: given a possibly-absolute image URL, strips it
// back down to the local /uploads/... path if it points at our own API
// server, so re-submitting an untouched existing image doesn't resend a
// full host-qualified URL. Anything else is returned unchanged - notably
// this must check startsWith(apiBaseUrl), not just includes('/uploads/'),
// since GCS object keys also contain "/uploads/" and collapsing one of
// those would strip its host/bucket and break the URL.
export const toLocalUploadPath = (imageUrl) => {
  if (!imageUrl || typeof imageUrl !== 'string') {
    return imageUrl;
  }
  const apiBaseUrl = process.env.REACT_APP_BASE_URL || '';
  if (apiBaseUrl && imageUrl.startsWith(apiBaseUrl) && imageUrl.includes('/uploads/')) {
    return `/uploads/${imageUrl.split('/uploads/')[1]}`;
  }
  return imageUrl;
};

export const getVideoUrl = (videoUrl, baseUrl) => {
  if (!videoUrl) return '';
  return videoUrl.startsWith('http') ? videoUrl : `${baseUrl}${videoUrl}`;
};

export const getCoverImageUrl = (coverImage, baseUrl) => {
  if (!coverImage) return '';
  return coverImage.startsWith('http') ? coverImage : `${baseUrl}${coverImage}`;
};

export const getVideoMetadata = (post) => {
  if (!post) return null;
  
  try {
    const metadata = typeof post.videoMetadata === 'string' 
      ? JSON.parse(post.videoMetadata) 
      : post.videoMetadata;

    return {
      title: metadata?.title || '',
      author: metadata?.author || '',
      cover: metadata?.cover || '',
      duration: metadata?.duration || '',
      views: metadata?.views || 0,
      description: metadata?.description || '',
      playUrl: metadata?.playUrl || '',
      source: metadata?.source || 'upload'
    };
  } catch (error) {
    console.error('Error parsing video metadata:', error);
    return null;
  }
}; 